import React from "react";
import ProgramDetailsSection from "../../../../components/template/ProgramDetailSection";

const Synergize = () => {
  return (
    <ProgramDetailsSection
      title="SYNERGIZE"
      tagline="Leadership Alignment Workshop"
      highlights={[
        "Science-Based",
        "Led by IIT/IIM Alumni",
        "Experiential Learning",
      ]}
      description="SYNERGIZE strengthens leadership alignment by fostering trust, collaboration, shared purpose, and collective ownership among senior leadership teams."
      duration="1.5 Days"
      focusAreas={[
        "Holistic Wellbeing & Balance",
        "Personal & Organizational Values",
        "Leadership Alignment",
        "Team Cohesion & Trust",
        "Shared Vision & Goals",
      ]}
      outcomes={[
        "Strengthen alignment between personal values, leadership actions, and organizational priorities.",
        "Enhance trust, collaboration, and collective ownership within the leadership team.",
        "Build greater clarity and commitment around shared goals and future direction.",
      ]}
      images={[
        "../../../cw/CW17.JPG",
        "../../../cw/CW12.JPG"
      ]}
    />
  );
};

export default Synergize;